import { useQuery } from "@tanstack/react-query"

import KPIChartCarousel from "@/features/dashboards/components/KPIChartCarousel.tsx"

import { getChartData } from "../api/getChartData.ts"

import type { DailyChartConfig } from "../types/dailyChartTypes.ts"

export default function DailyChartDisplay({ config }: { config: DailyChartConfig }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["dailyChart", { location: 3 }],
    queryFn: () => getChartData(config),
  })

  return (
    <div className="col-span-4 md:col-span-2 h-[350px] md:h-[475px]">
      <KPIChartCarousel
        config={{
          title: "Daily Charts",
          variant: "bar",
          includeTargets: false,
          labels:
            data == undefined
              ? []
              : data.map((kpi) => (
                  <>
                    {kpi.name} <i>({kpi.unit})</i>
                  </>
                )),
        }}
        data={data}
        isLoading={isPending}
        isError={isError}
      />
    </div>
  )
}
